import { Blueprint, InitType } from "../blueprint";
import { makeState, TimerState } from "./state/timer.state";
import { timerActions } from "./state/timer.actions";
import { InstanceState as InstanceState } from "../../instance-service/instance-state.service";
import { StateServices } from "../../instance-service/i-state-services";
import { RenderServices } from "../../instance-service/i-render-services";
import { Surface } from "../../../surface/primitives/surface";
import { Entity } from "src/app/state/entities/entity.model";
import { selectWorldTick10s } from "src/app/state/world/world.selector";
import { selectCameraState } from "src/app/state/camera/camera.selector";
import { BlueprintSurface } from "../blueprint-movable";
import { TimerSelectors } from "./state/timer.selector";
import {NetworkServices} from "../../instance-service/i-network-services";

export class TimerBlueprint extends BlueprintSurface {
  override id: string;
  override type: string = "Timer"
  override state: InstanceState<TimerState, ReturnType<typeof timerActions>, ReturnType<typeof TimerSelectors>, TimerBlueprint>
  actions$: ReturnType<typeof timerActions>
  selectors: ReturnType<typeof TimerSelectors>


  override async init(config: {
    entity: Entity, 
    initType: InitType, 
    stateServices: StateServices,
    renderServices: RenderServices,
    networkServices: NetworkServices
  }) {
    super.init(config)
    this.state = makeState(this)
    this.actions$ = this.state.actions
    this.selectors = this.state.selectors
    this.select(this.selectors.selectTimerState).subscribe(
      (state) => {
        console.log("Timer: ", this.id, state.minutes, ":", ('00' + state.seconds).slice(-2))
      })
    const store = config.stateServices.store
    store.select(selectCameraState).subscribe((cameraState) => {
      this.camera = cameraState;
    });
    store.select(selectWorldTick10s).subscribe((tickCount) => {
      this.dispatch(this.actions$.tick())
    });
  }


  override destroy(): void {
    throw new Error("Method not implemented.");
  }


  override async makeSurface(config: { entity: Entity; initType: InitType; stateServices: StateServices; renderServices: RenderServices; }): Promise<Surface> {
    const surface = await config.renderServices.surfaceService.create({
      left: 0,
      top: 0,
      right: 200,
      bottom: 100,
    });
    return surface
  }

}
